module.exports = __webpack_public_path__ + "3660d6582f811296309cb5f085b1c7b8.pdf";